class FetchConfig {
  constructor(config = {}) {
    this.config = config;
  }

  attachHeaders(headerObj = {}) {
    let headersConfig = (this.config && this.config.headers) || {};

    this.config.headers = Object.assign(headersConfig, headerObj);
    return this.config;
  }
}

export { FetchConfig };
